var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcousticSoundsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.813,
    height: 4,
    viewBox: "0 0 4.813 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc12ed2d-5e38-4081-8bb8-90f79bfd0df0",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bbb9fffc-b3f1-4c34-8b95-125d37db57ad",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4,2,0,4,4ZM3,1A1,1,0,0,0,4,2V.1A.871.871,0,0,0,3,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,2.1V4a.919.919,0,0,0,.9-1A.839.839,0,0,0,3.9,2.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcousticSoundsLogo);
export default __webpack_public_path__ + "static/media/acoustic-sounds-logo.d0363eac28cd1d4450795a84ebc2ecfe.svg";
export { ForwardRef as ReactComponent };